import { Component } from '@angular/core';
import { DynamicItem } from 'src/app/main/dynamic/dynamic-item';

@Component({
  selector: 'app-group',
  template: `
    <div class="group-horizontal">
      <app-dynamic *ngFor="let attribute of attribute.attributes"
                   [attribute]="attribute"
                   [envOptions]="envOptions"
                   (onEmit)="emitEvents($event)">
      </app-dynamic>
    </div>
  `,
  styleUrls: ['./group.component.scss']
})
export class GroupComponent extends DynamicItem {}
